import * as yup from "yup";

export const serviceSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  description: yup.string().required("Description is required"),
  type: yup.string().required("Type is required"),
  price: yup
    .number("Please input price")
    .min(0, "The minimum amount is 0")
    .typeError("Price is required")
    .required("Price is required"),
  imageFile: yup.object(),
  imageUrl: yup.string().required("Image Url is required"),
  sequence: yup
    .number()
    .min(0, "The minimum number is zero")
    .typeError("Sequence is required")
    .required("Sequence is required"),
});
